import { RESOURCE_NAME as BENEFITS } from '@esentai/core/features/benefits/consts';
import { RESOURCE_NAME as EFS_VISIT_RECORDS } from '@esentai/core/features/efsVisitRecords/consts';
import { RESOURCE_NAME as GIFT_CERTIFICATES } from '@esentai/core/features/giftCertificates/consts';
import { RESOURCE_NAME as KKMS } from '@esentai/core/features/kkms/consts';
import { RESOURCE_NAME as MALL_BONUSES } from '@esentai/core/features/mallBonuses/consts';
import { RESOURCE_NAME as MALL_STATS } from '@esentai/core/features/mallStats/consts';
import { RESOURCE_NAME as MERCHANTS } from '@esentai/core/features/merchants/consts';
import { RESOURCE_NAME as PURCHASE_HISTORY } from '@esentai/core/features/purchases/consts';
import { RESOURCE_NAME as RECONCILIATIONS_CP } from '@esentai/core/features/reconciliation/consts';
import { RESOURCE_NAME as RECONCILIATIONS_HISTORY } from '@esentai/core/features/reconciliationHistory/consts';
import { RESOURCE_NAME as RECONCILIATION_PERIOD_BONUS_DETAILS } from '@esentai/core/features/reconciliationPeriodBonusDetails/consts';
import { RESOURCE_NAME as RECONCILIATION_RECEIPTS } from '@esentai/core/features/reconciliationReceipts/consts';
import { RESOURCE_NAME as RECONCILIATION_REFUNDS } from '@esentai/core/features/reconciliationRefunds/consts';
import { RESOURCE_NAME as RECONCILIATION_STORE_BONUS_DETAILS } from '@esentai/core/features/reconciliationStoreBonusDetails/consts';
import { RESOURCE_NAME as RECONCILIATION_STORE_TO_CP } from '@esentai/core/features/reconciliationStoreToCp/consts';
import { RESOURCE_NAME as SALES_TURNOVERS } from '@esentai/core/features/salesTurnovers/consts';
import { RESOURCE_NAME as STORE_BONUSES } from '@esentai/core/features/storeBonuses/consts';
import { RESOURCE_NAME as STORES } from '@esentai/core/features/stores/consts';
import { RESOURCE_NAME as USERS } from '@esentai/core/features/users/consts';
import {
  can,
  CREATE,
  DELETE,
  EDIT,
  permit,
  VIEW,
} from '@esentai/core/policy-dsl';

import { RESOURCE_NAME as PERSONNEL } from '@/features/personnel/consts';
import { RESOURCE_NAME as USERS_STATISTICS } from '@/features/usersStatistics/consts';

import { VIEW_NAVIGATION_BAR } from '../consts/permissions';

export default [
  can(VIEW_NAVIGATION_BAR),
  permit(BENEFITS, [VIEW]),
  permit(EFS_VISIT_RECORDS, [VIEW]),
  permit(GIFT_CERTIFICATES, [VIEW]),
  permit(KKMS, [VIEW]),
  permit(MALL_BONUSES, [VIEW]),
  permit(MALL_STATS, [VIEW, EDIT, CREATE, DELETE]),
  permit(MERCHANTS, [VIEW]),
  permit(PERSONNEL, [VIEW]),
  permit(PURCHASE_HISTORY, [VIEW]),
  permit(RECONCILIATIONS_CP, [VIEW]),
  permit(RECONCILIATIONS_HISTORY, [VIEW]),
  permit(RECONCILIATION_PERIOD_BONUS_DETAILS, [VIEW]),
  permit(RECONCILIATION_RECEIPTS, [VIEW]),
  permit(RECONCILIATION_REFUNDS, [VIEW]),
  permit(RECONCILIATION_STORE_BONUS_DETAILS, [VIEW]),
  permit(RECONCILIATION_STORE_TO_CP, [VIEW]),
  permit(SALES_TURNOVERS, [VIEW]),
  permit(STORES, [VIEW]),
  permit(STORE_BONUSES, [VIEW]),
  permit(USERS, [VIEW]),
  permit(USERS_STATISTICS, [VIEW]),
];
